import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

import { useSelector } from "react-redux";

import { ENV } from '../../API/config';
import { myLabelInput, unoTheme } from '../../assets/styles/unoTheme';
import MyAutoComplete from '../utils/MyAutoComplete';
import UnoButton from '../utils/UnoButton';
import { getClientLabelWithMigrationFlag } from '../utils/utils';

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: theme.spacing(2),
        minWidth: '480px',
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        }
    },

    label: myLabelInput,

    warningColor: {
        color: unoTheme.warningColor
    },

    hint: {
        fontSize: '.85em',
        color: unoTheme.defaultTextColor,
        marginTop: theme.spacing(1),
    },

}));

/**
 * Passo 1 do fluxo de importação de lançamentos entre clientes: escolha do cliente de
 * origem. A listagem vem de state.activeClients, que já é carregada por consultoria em
 * UnoDashboard, então não há consulta nova aqui.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {function} props.handleSelectedSourceClient recebe o cliente escolhido
 * @param {function} props.handleClose
 */
export default function SelectSourceClientModal({ open, handleSelectedSourceClient, handleClose }) {

    const classes = useStyles();

    const clientOn = useSelector(state => state.clientOn);
    const activeClients = useSelector(state => state.activeClients);

    const [selectedClient, setSelectedClient] = useState(null);

    const clientOnId = useMemo(() => clientOn && clientOn.client ? clientOn.client.id : null, [clientOn]);

    const options = useMemo(() => (activeClients || []).filter(el => el.id !== clientOnId),
        [activeClients, clientOnId]);

    useEffect(() => {

        if (open) {
            setSelectedClient(null);
        }

    }, [open])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            onClose={() => handleClose()}>

            <DialogTitle className={classes.dialogTitle}>
                {"Importar lançamentos de outro cliente"}
            </DialogTitle>

            <DialogContent className={classes.contentModal}>

                <MyAutoComplete
                    outerlabel={'Cliente de origem'}
                    options={options}
                    autoComplete
                    value={selectedClient}
                    onChange={(event, newValue) => setSelectedClient(newValue)}
                    placeholder={"Selecione o cliente"}
                    getOptionLabel={(option) => (ENV === "DEV" || ENV === "HOMOLOG" ? option.id + " / " : "") + getClientLabelWithMigrationFlag(option)}
                    getOptionSelected={(option, value) => option.id === value.id}
                    renderOption={(option) => (
                        <React.Fragment key={'source-client-' + option.id}>
                            <span>{getClientLabelWithMigrationFlag(option)}</span>
                        </React.Fragment>
                    )}
                />

                <Typography className={classes.hint}>
                    {'As contas, ativos, títulos, saldos e movimentações do cliente de origem serão analisados '
                        + 'e comparados com os de '
                        + (clientOn && clientOn.client ? clientOn.client.label_name : 'destino')
                        + '. Nada é gravado nesta etapa.'}
                </Typography>

            </DialogContent>

            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() => handleClose()} color="secondary">
                    {'Cancelar'}
                </UnoButton>

                <UnoButton
                    disabled={!selectedClient}
                    onClick={() => handleSelectedSourceClient(selectedClient)}
                    color="primary">
                    {"Analisar informações"}
                </UnoButton>

            </DialogActions>

        </Dialog>
    );
}
